import { useMemo } from "react";
import { useSelector } from "react-redux";
import { DEFAULT_MODULES, MODULE_KEYS } from "../constants/modules";

/* The component-facing half of utils/modules: same rule, but subscribed, so a
 * screen re-renders when the workspace turns a module on or off, its plan
 * expires or renews, or the user switches to a different workspace. */
export const useModules = () => {
  const orgUuid = useSelector(({ auth }) => auth.organization?.uuid);
  const hasSubscription = useSelector(
    ({ auth }) => auth.organization?.hasPlan === true,
  );
  const stored = useSelector(({ auth }) => auth.organization?.modules);

  return useMemo(() => {
    const configured = Array.isArray(stored)
      ? stored.filter((key) => MODULE_KEYS.includes(key))
      : DEFAULT_MODULES;
    /* `modules` remembers what the workspace wants; an active subscription
     * decides whether those sections are actually available. Keeping the two
     * separate means an expired workspace loses every paid entry immediately,
     * without erasing its choices for a later renewal. */
    const enabled = hasSubscription ? configured : [];
    const visible = hasSubscription ? configured : MODULE_KEYS;

    return {
      orgUuid,
      configured,
      enabled,
      visible,
      hasSubscription,
      /* Never answered — the settings tab says so rather than showing the
       * defaults as if they had been chosen. */
      isDefault: !Array.isArray(stored),
      has: (key) => enabled.includes(key),
    };
  }, [stored, orgUuid, hasSubscription]);
};

export default useModules;
